import BackgroundMixTranslations from '../../../../../Spirit/Admin/Interfaces/Models/BackgroundFilesService/BackgroundMixTranslations';
import CropAndSaveImageRequest from '../../../../../Spirit/Common/FileManager/Models/CropAndSaveImageRequest';

export default class UpdateBackgroundMixRequest  {
	Id?: number = null;
	Translations: Array<BackgroundMixTranslations> = null;
	BackImage: CropAndSaveImageRequest = null;
	CoverImage: CropAndSaveImageRequest = null;
	AnimationId?: string = '';
	BackgroundFileIds: Array<string> = null;
	constructor(obj?: Partial<UpdateBackgroundMixRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
